<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Many thanks to my talented daughter-in-law, Debbie, for her illustrations and cover design. Your amazing artwork brings my characters to life. Also thanks to the team at Austin Macauley for believing in my stories.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?6c91f7de